import * as classnames from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { ReviewsNumber } from './ReviewsNumber';
import { ReadReviews } from './ReadReviews';
import { starsWrapperTheme } from '../theme/default-theme';
import { RatingWrapper } from './RatingWrapper';
import { AverageRating } from './AverageRating';
import { StarsSimplified } from './StarsSimplified';
import { NUMBER_OF_STARS } from '../constants/Rating';

export interface IRating {
    className?: string;
    percentageRating: number;
    reviewsNumber: number;
    showReviewsNumber?: boolean;
    showReadReviews?: boolean;
    readReviewsLabel?: string;
    firstToWriteReviewLabel: string;
    numberOfStars?: number;
    onReadReviewsClick?(): void;
    onWriteReviewsClick?(): void;
    hideStars?: boolean;
    hideReviewsLabel?: boolean;
    reviewsNumberLabel?: string;
    showReviewsNumberLabel?: boolean;
    averageRating?: number;
    showEmptyStars?: boolean;
    isClickable: boolean;
}

const StarsWrapper = styled.span`
    margin: 0;
    display: inline-block;
    position: relative;
    padding: 0;
    user-select: none;
    ${starsWrapperTheme};
`;

export const Rating = observer((props: IRating) => {
    const {
        numberOfStars = NUMBER_OF_STARS,
        percentageRating,
        reviewsNumber,
        onReadReviewsClick,
        onWriteReviewsClick,
        readReviewsLabel,
        firstToWriteReviewLabel,
        showReviewsNumber,
        hideStars,
        showReadReviews,
        hideReviewsLabel,
        reviewsNumberLabel,
        showReviewsNumberLabel,
        averageRating,
        showEmptyStars,
        className,
        isClickable
    } = props;

    const ratingClassNames = classnames('elc-rating', 'js-rating', className);

    const shouldShowStars = !!reviewsNumber && !hideStars;
    const shouldShowAvgRating = !!reviewsNumber && !!averageRating;

    return (
        <RatingWrapper
            className={ratingClassNames}
            onRatingWrapperClick={!!reviewsNumber ? onReadReviewsClick : onWriteReviewsClick}
            isClickable={isClickable}
        >
            <>
                {(shouldShowStars || showEmptyStars) && (
                    <StarsWrapper className="elc-stars-wrapper">
                        <StarsSimplified percentageRating={percentageRating} />
                    </StarsWrapper>
                )}
                {shouldShowAvgRating && (
                    <AverageRating numberOfStars={numberOfStars} averageRating={averageRating} />
                )}
                {!!reviewsNumber && showReviewsNumber && (
                    <ReviewsNumber
                        reviewsNumber={reviewsNumber}
                        reviewsNumberLabel={reviewsNumberLabel}
                        showReviewsNumberLabel={showReviewsNumberLabel}
                    />
                )}
                {showReadReviews && (
                    <ReadReviews
                        readReviewsLabel={readReviewsLabel}
                        reviewsNumber={reviewsNumber}
                        firstToWriteReviewLabel={firstToWriteReviewLabel}
                        hideReviewsLabel={hideReviewsLabel}
                    />
                )}
            </>
        </RatingWrapper>
    );
});
